import axiosClient from "api/axios_client.js";

// Calls shared by the pages under role-and-permissions/.
const apiRoleAndPermissions = {
  // Active roles (id + role), e.g. for role pickers.
  getRoles: () => axiosClient.get(`/user-role-module/user-role/get-all`),
};

export default apiRoleAndPermissions;
